import React from 'react'

export default function LogIn() {
  return (
    <div id='Login'>
        <div className='card'>
            Log In
            <span>No account? <a href='/signup'><strong>Sign Up</strong></a></span>
        </div>
    </div>
  )
}
